import { create } from 'zustand';

const ACTION_LABELS = {
  add_component: 'Adding component',
  delete_component: 'Deleting component',
  rename_component: 'Renaming component',
  add_edge: 'Connecting components',
  delete_edge: 'Disconnecting components',
  update_edge: 'Updating connection',
  update_component_data: 'Configuring component',
  layout: 'Arranging workflow',
  _tool_activity_start: 'Working…',
};

const useGhostCursorStore = create((set, get) => ({
  targetComponentId: null,
  actionLabel: null,
  lastUpdateAt: 0,

  setActivity: ({ componentId, action }) => {
    if (!componentId && !action) return;
    const label = ACTION_LABELS[action] || ACTION_LABELS._tool_activity_start;
    set({
      targetComponentId: componentId || get().targetComponentId,
      actionLabel: label,
      lastUpdateAt: Date.now(),
    });
  },

  clear: () =>
    set({
      targetComponentId: null,
      actionLabel: null,
      lastUpdateAt: 0,
    }),
}));

export default useGhostCursorStore;
